module.exports = __webpack_public_path__ + "static/media/VectorForward.0eb42f7c.svg";